module.exports = "mutation proposalRejected($adviceRequestId:String!){proposalRejected(adviceRequestId:$adviceRequestId)}"